import React from 'react';
import Lottie from 'react-lottie-player';

import * as animacao from './dispositivos.json';

const Dispositivos = (): React.ReactElement => (
  <Lottie loop play animationData={animacao} className="w-100" />
);

export default Dispositivos;
